import { queryClient } from '../../page/ReactQueryProvider';
import { PageContext } from '../../types';
import { pageClient } from '../page.client';

export const getPageDsl = async (url: string, dslParams: PageContext) => {
  return await queryClient.fetchQuery({
    queryKey: ['page-dsl', url, JSON.stringify(dslParams)],
    queryFn: () => {
      return pageClient.getPageDsl(url, dslParams);
    },
    staleTime: Infinity,
  });
};
